export const resource = {
	GET_RESOURCES: "resource/get",
	ADD_RESOURCE: "resource/add",
	UPDATE_RESOURCE: "resource/update",
	DELETE_RESOURCE: "resource/delete",
	GET_RESOURCE_DETAIL: "resource/detail",
}

export default resource
